import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Macarena Giménez',
    role: 'Recruiter Senior',
    city: 'Buenos Aires',
    initials: 'MG',
    color: 'bg-blue-100 text-blue-700',
    quote: 'Antes manejaba todo de memoria y se me escapaban candidatos. Ahora cada búsqueda tiene un orden claro y mis clientes lo notan.'
  }, {
    name: 'Lucía Martínez',
    role: 'Talent Acquisition',
    city: 'Córdoba',
    initials: 'LM',
    color: 'bg-emerald-100 text-emerald-700',
    quote: 'El módulo de entrevistas me cambió la forma de trabajar. Dejé de improvisar y ahora presento ternas mucho más sólidas.'
  }, {
    name: 'Florencia Ruiz',
    role: 'Consultora de RRHH',
    city: 'Rosario',
    initials: 'FR',
    color: 'bg-purple-100 text-purple-700',
    quote: 'Manejo 5 búsquedas en simultáneo y siempre era un caos. Las planillas de seguimiento son exactamente lo que necesitaba para no perder el control.'
  }, {
    name: 'Tomás Villalba',
    role: 'Selector IT',
    city: 'Mendoza',
    initials: 'TV',
    color: 'bg-amber-100 text-amber-700',
    quote: 'Vale cada centavo. Solo con el tiempo que me ahorro filtrando CVs ya recuperé la inversión el primer día.'
  }, {
    name: 'Agustina López',
    role: 'Analista de Selección',
    city: 'La Plata',
    initials: 'AL',
    color: 'bg-rose-100 text-rose-700',
    quote: 'Me dio la estructura que me faltaba para verme más profesional frente a los hiring managers. Súper recomendable.'
  }];
  return <section className="py-24 bg-slate-50" data-id="element-136">
      <div className="max-w-6xl mx-auto px-6" data-id="element-137">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-138">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className={`bg-white p-8 rounded-2xl shadow-sm border border-slate-100 ${idx === 3 ? 'md:col-span-2 lg:col-span-1' : ''} ${idx === 4 ? 'md:col-span-2 lg:col-span-2 lg:max-w-md lg:mx-auto' : ''}`} data-id="element-139">
              <div className="flex gap-1 mb-4" data-id="element-140">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-141" />)}
              </div>
              <p className="text-slate-700 italic mb-6 leading-relaxed" data-id="element-142">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-143">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg ${t.color}`} data-id="element-144">
                  {t.initials}
                </div>
                <div data-id="element-145">
                  <div className="font-bold text-slate-900" data-id="element-146">{t.name}</div>
                  <div className="text-sm text-slate-500" data-id="element-147">
                    {t.role} · {t.city}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}